import script from "./result-item-template.vue?vue&type=script&setup=true&lang=ts"
export * from "./result-item-template.vue?vue&type=script&setup=true&lang=ts"

import "./result-item-template.vue?vue&type=style&index=0&id=7c7e16d2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c7e16d2"]])

export default __exports__